import dayjs from 'dayjs';

/**
 * 来月の場合trueを返す
 * @param targetDate
 */
export const isNextMonth = (targetDate: Date | string) => {
  const nextMonth = new Date();
  nextMonth.setDate(1);
  // 翌月に同じ日付が存在しない場合翌々月になる為、月初に上書きした上で翌月に更新する
  // 例）1/31の場合2/31は存在せず3/3になる
  nextMonth.setMonth(nextMonth.getMonth() + 1);

  return dayjs(nextMonth).format(`YYYYMM`) === dayjs(targetDate).format(`YYYYMM`);
};

export default isNextMonth;
